import { render, staticRenderFns } from "./TestDescriptorsDraggable.vue?vue&type=template&id=1682e9f6&scoped=true"
import script from "./TestDescriptorsDraggable.vue?vue&type=script&lang=js"
export * from "./TestDescriptorsDraggable.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=1682e9f6&prod&scoped=true&lang=css&external"
import style1 from "./TestDescriptorsDraggable.vue?vue&type=style&index=1&id=1682e9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1682e9f6",
  null
  
)

export default component.exports